import c from '../common';

export default {

  //Column
  "Time": "時間",

  "status": c.status.chn,
  "used": "成功使用",

  "currency": "貨幣",

  "amount": "金額(CAD)",

  "download": c.download.chn,

  "discountName": c.discount.chn + "名稱",
  "issueId": "發行ID",
};